// @ts-strict-ignore
import { IntegrationCapability, IntegrationType, StabilityInfo } from '../../types';
import * as React from 'react';
import { antGrey, buildContainerStyle, runwayColors, titleStyle } from '../styles/globalStyles';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import Divider from 'antd/lib/divider';
import Progress from 'antd/lib/progress/progress';
import { PlanRestrictedFeatureWrapper } from '@/components/planRestrictions/PlanRestrictedFeatureWrapper';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';

export const getFormattedStabilityMetrics = (stabilityInfo: StabilityInfo) => {
    let decimalPlaces = stabilityInfo.userStability === 100 ? 0 : 3;
    const userStability =
        stabilityInfo.userStability != null ? `${stabilityInfo.userStability.toFixed(decimalPlaces)}%` : '-';

    decimalPlaces = stabilityInfo.sessionStability === 100 ? 0 : 3;

    const sessionStability =
        stabilityInfo.sessionStability != null ? `${stabilityInfo.sessionStability.toFixed(decimalPlaces)}%` : '-';

    decimalPlaces = stabilityInfo.sessionAdoption >= 0.01 && stabilityInfo.sessionAdoption < 1 ? 2 : 0;
    const sessionAdoption =
        stabilityInfo.sessionAdoption != null ? `${stabilityInfo.sessionAdoption.toFixed(decimalPlaces)}%` : 'Unknown';

    return {
        userStability,
        sessionStability,
        sessionAdoption,
    };
};
interface StabilityMetricsProps extends StabilityInfo {
    maxWidth?: number;
    backgroundColor: string;
    isRunwayAutoPaused?: boolean;
}

const StabilityMetrics: React.FC<StabilityMetricsProps> = (props: StabilityMetricsProps) => {
    const titleTextStyle: React.CSSProperties = {
        ...titleStyle,
        color: antGrey.grey7,
        fontSize: 10,
        lineHeight: 1.6,
    };

    const stabilityValueStyle: React.CSSProperties = {
        fontSize: 20,
        fontWeight: 600,
        color: antGrey.grey8,
        marginTop: 24,
    };

    const stabilityItemContainerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
    };

    const autoPausedProps: React.CSSProperties =
        props.isRunwayAutoPaused === true ?
            {
                color: runwayColors.statusRed,
            }
        :   {};

    const { userStability, sessionStability, sessionAdoption } = getFormattedStabilityMetrics(props);

    const disabledDashesText = <Text style={{ ...stabilityValueStyle, color: antGrey.grey6 }}>--</Text>;

    return (
        <PlanRestrictedFeatureWrapper
            integrationCapability={IntegrationCapability.StabilityMonitoring}
            requiresTooltip
            tooltipNoIcon
        >
            {(isDisabled) => (
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <div
                        style={{
                            ...buildContainerStyle,
                            backgroundColor: props.backgroundColor,
                            flexGrow: 1,
                            maxWidth: props.maxWidth,
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: 16,
                        }}
                    >
                        <Space
                            split={<Divider type="vertical" style={{ height: '100%' }} />}
                            style={{ height: '100%', alignItems: 'stretch', marginRight: 8 }}
                        >
                            <div style={stabilityItemContainerStyle}>
                                <Text style={{ ...titleTextStyle }}>Crash-free users</Text>

                                {isDisabled ?
                                    disabledDashesText
                                :   <Text style={{ ...stabilityValueStyle, ...autoPausedProps }}>{userStability}</Text>}
                            </div>
                            <div style={stabilityItemContainerStyle}>
                                <Text style={{ ...titleTextStyle }}>Crash-free sessions</Text>
                                {isDisabled ?
                                    disabledDashesText
                                :   <Text style={{ ...stabilityValueStyle, ...autoPausedProps }}>
                                        {sessionStability}
                                    </Text>
                                }
                            </div>
                        </Space>
                        {props.integrationId == IntegrationType.Firebase && (
                            <TooltipInfoIcon
                                tooltipContent="The accuracy and recency of Firebase stability info depends on the Google Analytics -> BigQuery export settings in your Firebase project. Unless you have Streaming enabled, data only updates once per day."
                                tooltipProps={{ placement: 'topRight', arrow: { pointAtCenter: true } }}
                            />
                        )}
                    </div>
                    <div style={{ marginTop: 12 }}>
                        <Text style={{ ...titleTextStyle, ...(isDisabled ? { color: antGrey.grey6 } : {}) }}>
                            {isDisabled ? '' : `${sessionAdoption} `}adoption rate (sessions, last{' '}
                            {props.adoptionPeriodString ?? '24H'})
                        </Text>
                        <Progress
                            percent={isDisabled ? 0 : (props.sessionAdoption ?? 0)}
                            strokeColor={runwayColors.statusGreen}
                            strokeLinecap="butt"
                            showInfo={false}
                        />
                    </div>
                </div>
            )}
        </PlanRestrictedFeatureWrapper>
    );
};

export default StabilityMetrics;
